"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalAuthContext = void 0;
exports.ExternalAuthProvider = ExternalAuthProvider;
exports.useExternalAuth = useExternalAuth;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../@hooks");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef CertificateModel
 * @type {import("web-pki-fixed").CertificateModel}
 */

/**
 * @typedef ExternalAuthPageProps
 * @type {import("./AuthContext").AuthPageProps}
 */
/**
 * @type {React.Context<ExternalAuthPageProps | undefined>}
 */
var ExternalAuthContext = (0, _react.createContext)(undefined);

/**
 * @param {ExternalAuthPageProps} props
 * @returns {JSX.Element}
 */
exports.ExternalAuthContext = ExternalAuthContext;
function ExternalAuthProvider(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useWorkfluxPortal = (0, _hooks.useWorkfluxPortal)(),
    loading = _useWorkfluxPortal.loading,
    workfluxPortal = _useWorkfluxPortal.workfluxPortal,
    workfluxPortalLicense = _useWorkfluxPortal.workfluxPortalLicense;
  var external = Object.keys(workfluxPortal).length > 0;
  return /*#__PURE__*/_react["default"].createElement(ExternalAuthContext.Provider, {
    value: _objectSpread(_objectSpread({}, rest), {}, {
      external: external,
      loading: loading,
      config: workfluxPortal,
      license: workfluxPortalLicense
    })
  }, children);
}
ExternalAuthProvider.propTypes = {
  app: _propTypes["default"].string.isRequired,
  urlProps: _propTypes["default"].shape({
    params: _propTypes["default"].shape({
      recoveryToken: _propTypes["default"].string
    }).isRequired
  }).isRequired,
  hideSpinner: _propTypes["default"].func.isRequired,
  showSpinner: _propTypes["default"].func.isRequired,
  showMessage: _propTypes["default"].func.isRequired,
  hideMessage: _propTypes["default"].func.isRequired,
  goToPage: _propTypes["default"].func.isRequired,
  auth: _propTypes["default"].shape({
    isAuthenticated: _propTypes["default"].bool.isRequired
  }).isRequired,
  loginWithSSO: _propTypes["default"].func.isRequired,
  loginWithCertificate: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node.isRequired,
  loginWithEmail: _propTypes["default"].func.isRequired,
  logout: _propTypes["default"].func.isRequired
};
function useExternalAuth() {
  var context = (0, _react.useContext)(ExternalAuthContext);
  if (!context) throw new Error('useExternalAuth must be used withing a ExternalAuthProvider');
  return context;
}